import React, { lazy, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import AuthLayout from '../container/profile/authentication/Index';

const Login = lazy(() => import('../container/profile/authentication/overview/SignIn'));
const SignUp = lazy(() => import('../container/profile/authentication/overview/Signup'));
const ForgotPass = lazy(() => import('../container/profile/authentication/overview/ForgotPassword'));
const ResetPassword = lazy(() => import('../container/profile/authentication/overview/ResetPassword'));

function AuthRoot() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/auth/login', { replace: true });
  }, [navigate]);

  return null;
}
const FrontendRoutes = React.memo(function FrontendRoutes() {
  return (
    <>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="forgotPassword" element={<ForgotPass />} />
        <Route path="register" element={<SignUp />} />
        <Route path="resetPassword" element={<ResetPassword />} />
        <Route path="*" element={<AuthRoot />} />
      </Routes>
    </>
  );
});

export default AuthLayout(FrontendRoutes);
